import { myBHDataTracker } from "@routes/MyBH/helper/myBHDataTracker";
import { BAASResponse } from "@typings/MyBH";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface MyBhStore {
  tags: BAASResponse[];
  setTags: (tags: BAASResponse[]) => void;
  followTag: (tag: BAASResponse) => void;
  unfollowTag: (tag: BAASResponse) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

const useMyBhStore = create(
  persist<MyBhStore>(
    (set) => ({
      tags: [],
      setTags: (tags: BAASResponse[]) => {
        set({ tags });
        myBHDataTracker(tags);
      },
      followTag: (tag: BAASResponse) => {
        set((store) => {
          const updatedTags = [tag, ...store.tags];

          myBHDataTracker(updatedTags); // Track data after updating the tags

          return { tags: updatedTags };
        });
      },
      unfollowTag: (tag: BAASResponse) => {
        set((store) => {
          const updatedTags = store.tags.filter(
            (_tag) => _tag.name.toLowerCase() !== tag.name.toLowerCase(),
          );

          myBHDataTracker(updatedTags); // Track data after updating the tags

          return { tags: updatedTags };
        });
      },
      isLoading: false,
      setIsLoading: (isLoading: boolean) => {
        set({ isLoading });
      },
    }),
    {
      name: "mybh-keywords", // unique name
      storage: createJSONStorage(() => localStorage), // Specify localStorage as the storage option
    },
  ),
);

export default useMyBhStore;
